import { ZenputCodes } from '../../../constants';
import { isConnected } from '../../../shared/utils/is';
import { BaseView } from './baseLayoutViews';

/**
 * When a user has no forms shared with them, this is what they will see.
 *
 * @author:david this view needs better defaults. Should be more generic icon/message, and UNKNON_ERROR zenput
 * code should use same generic icon/message @jira:MOBILE-576
 */
export const EmptyListMessage = BaseView.extend({
    template: '#tpl_empty_list_message',
    icon_class: 'df-form',
    i18n_key_title: null,
    i18n_key_message: 'mobile_empty_list_message_no_forms_available',
    image_filename: null,
    zenput_code: null, // One of ZenputCodes
    allow_retry: false, // If true you can allow retry when there is a fetch error
    action_button_title: null,

    events: {
        click: 'retry_fetch'
    },

    templateHelpers: function () {
        // Check for this just in case
        if (this.image_filename && this.icon_class) {
            $f.mobile.logging.log_error('Cannot have EmptyListMessage with both icon and image. Defaulting to image.', {
                image_filename: this.image_filename,
                icon_class: this.icon_class
            });
        }

        var helpers = {
            icon_class: this.icon_class,
            image_filename: this.image_filename,
            allow_retry: this.allow_retry,
            title: this.i18n_key_title && _t(this.i18n_key_title),
            message: _t(this.i18n_key_message) || this.i18n_key_message,
            action_button_title: this.action_button_title && _t(this.action_button_title)
        };

        if (!isConnected()) {
            // if offline, override caller's message with offline message
            helpers.icon_class = 'df-alert';
            helpers.image_filename = null;
            helpers.title = null;
            helpers.message = _t('mobile_empty_list_message_must_be_online');

            return helpers;
        }

        if (this.zenput_code === ZenputCodes.UNKNOWN_ERROR) {
            helpers.icon_class = 'df-alert';
            helpers.image_filename = null;
            helpers.title = null;
            helpers.message = _t('mobile_dashboard_zenput_code_unknown_error');

            return helpers;
        }

        return helpers;
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);

        $f.mobile.set_viewport();
    },

    retry_fetch: function () {
        if (!this.allow_retry) {
            return;
        }
        this.trigger('empty_view:retry_fetch');
    }
});
